import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.promise.finally.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { isPromise } from './types.js';
import { warn } from './console.js';
var PromiseQueue = /*#__PURE__*/function () {
  function PromiseQueue() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      quiet: false
    };
    _classCallCheck(this, PromiseQueue);
    this.queue = [];
    this.running = false;
    this.options = options;
  }
  return _createClass(PromiseQueue, [{
    key: "push",
    value: function push(method, thisObject) {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      return new Promise(function (resolve, reject) {
        if (_this.queue.length > 0) {
          if (_this.options.quiet !== false) {
            warn('Async method is being called but another async method is already running. ' + 'The new method will be delayed until the previous method completes.');
          }
        }
        _this.queue.push({
          method: method,
          thisObject: thisObject,
          args: args,
          resolve: resolve,
          reject: reject
        });
        _this.run();
      });
    }
  }, {
    key: "run",
    value: function run() {
      var _this2 = this;
      if (this.running) {
        return;
      }
      if (this.queue.length === 0) {
        return;
      }
      this.running = true;
      var queueItem = this.queue.shift();
      var res = queueItem.method.apply(queueItem.thisObject, queueItem.args);
      if (isPromise(res)) {
        res.then(queueItem.resolve, queueItem.reject).finally(function () {
          _this2.running = false;
          _this2.run();
        });
      } else {
        queueItem.resolve(res);
        this.running = false;
        this.run();
      }
    }
  }]);
}();
export { PromiseQueue };